import ResponsiveImage from '../../ResponsiveImage';
import { HORIZONTAL_BANNER_SIZE } from '../types';

interface IImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  size?: HORIZONTAL_BANNER_SIZE;
}

export const Image: React.FC<IImageProps> = ({
  size = HORIZONTAL_BANNER_SIZE.RESPONSIVE,
  ...props
}) => {
  const isResponsive = size === HORIZONTAL_BANNER_SIZE.RESPONSIVE;

  return (
    // tw-min-w-X not working, must hardcode in pixels
    <div
      className={`tw-flex tw-h-12 tw-w-12 tw-min-w-[48px] tw-items-center ${
        isResponsive
          ? 'desktop:tw-h-20 desktop:tw-w-20 desktop:tw-min-w-[80px]'
          : ''
      }`}
    >
      <ResponsiveImage {...props} />
    </div>
  );
};
